<span [class]="containerClasses">
  <span>{{ customLabel || (status | readableStatus) }}</span>
</span>
